import { Action } from 'redux';
import { LinkShareValues } from './link-share-values.interface';

export const LINK_SHARE_VALUES_REDUCER_NAME = 'linkShareValues';

const INITIAL_STATE: LinkShareValues = {
  agencyID: null,
  agentID: null,
  agentACSId: null,
  subject: null,
  urlKey: null
}

const INIT_LINK_SHARE_VALUES = 'INIT_LINK_SHARE_VALUES';
const SAVE_LINK_SHARE_VALUES = 'SAVE_LINK_SHARE_VALUES';
const SAVE_AGENCY_AND_AGENT_VALUES = 'SAVE_AGENCY_AND_AGENT_VALUES';

export class LinkShareAction implements Action {
  type: string;
  agentName: string;
  agencyID: string;
  agentID: string;
  agentACSId: string;
  subject: string;
  urlKey: string;
}


export function saveLinkShareValues(linkShareValues: LinkShareValues) {
  return {
    type: SAVE_LINK_SHARE_VALUES,
    agentName: linkShareValues.agentName,
    agencyID: linkShareValues.agencyID,
    agentID: linkShareValues.agentID,
    agentACSId: linkShareValues.agentACSId,
    subject: linkShareValues.subject,
    urlKey: linkShareValues.urlKey
  };
}

export function saveAgencyAndAgentValues(agencyId, agentId, agentName?) {
  return {
    type: SAVE_AGENCY_AND_AGENT_VALUES,
    agentName: agentName,
    agencyID: agencyId,
    agentID: agentId
  };
}

/**
 * Login info reducers
 */
export function LinkShareValues(state: LinkShareValues = INITIAL_STATE, action: LinkShareAction) {
  let copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_LINK_SHARE_VALUES:
      copiedState = action;
      return Object.assign({}, state, copiedState);
    case SAVE_AGENCY_AND_AGENT_VALUES:
      copiedState = action;
      return Object.assign({}, state, copiedState);
    case INIT_LINK_SHARE_VALUES:
    default:
      return state;
  }
}
